// REACT & Libraries
import { useEffect } from "react";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

// Role Guard
import RoleGuard from "../../RoleGuard";

// Components
import EmpTypesContainer from "../../../Components/MasterData/EmploymentTypes";

const EmploymentTypes = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Employment Type Master Data";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "data-master"]}
      />

      {/* Main content */}
      <EmpTypesContainer />
    </>
  );
};

export default EmploymentTypes;
